/**
 * 参数接口
 */

import instance from '@/utils/axios';

/**
 * @description 获取物质列表
 * @param {{ libCode: 'big'|'fda', keywords: string }} params
 */
export function getMaterialList(params) {
  return instance.get('baseinfo/material-list', {
    params
  });
}

/**
 * @description 获取物质详情
 * @param {{materialId: string}} params
 */
export function getMaterialDetails(params) {
  return instance.get('baseinfo/material-base-info', {
    params
  });
}

/**
 * @description 获取fcbr 自定义库列表
 * @param {{limit: number, matName: string, offset:number,sn:string}} data
 */
export function getFcbrMatList(data) {
  return instance.post('/fcbrMatLibrary/findList', {
    ...data
  });
}

/**
 * @description 获取fcbr 自定义库物质详情
 * @param {{id:string}} data
 */
export function getFcbrMatDetails(data) {
  return instance.post('/fcbrMatLibrary/detail', {
    ...data
  });
}

/**
 * @description 删除fcbr 自定义库
 * @param {string} id
 */
export function delFcbrMatById(id) {
  return instance.post('/fcbrMatLibrary/del', {
    id
  });
}

/**
 * @description 保存或更新 fcbr 自定义库
 * @param {{id?:string, matName:string, remarks: string, sn:string}} data
 */
export function saveFcbrMaterial(data) {
  return instance.post('/fcbrMatLibrary/save', {
    ...data
  });
}

/**
 * fcbr100cfr 采样
 * @param {Object} data
 * @param {string} data.id 库id
 * @param {string} data.sn 设备号
 * @param {1|2} data.sampleType  1-本底，2-进样
 * @param {0|1} data.type  1-开始，0-结束
 */
export function setFcbrSample(data) {
  return instance.post('/fcbrMatLibrary/sample', {
    ...data
  });
}

/**
 * 获取采样状态
 * @param {Object} data
 * @param {string} data.sn 设备sn
 * @param {string} data.id 库id
 * @returns {0|1|2|3|4|5} 0-初始；1-本底采样中；2-进样中；3-本底采样完成；4-进样完成；5-筛选完成
 */
export function getFcbrSampleStatus(data) {
  return instance.get('/fcbrMatLibrary/sampleStatus', {
    params: data
  });
}

/**
 * 保存筛选
 * @param {Object} data
 * @param {string} data.sn: 设备sn
 * @param {string} data.id: 库id,
 * @param {number} data.startTime 1743155119366,
 * @param {number} data.endTime 1743155159479
 * @returns
 */
export function saveFcbrMatLibFilter(data) {
  return instance.post('/fcbrMatLibrary/filter', { ...data });
}

/**
 * 获取采样数据
 * @param {Object} data
 * @param {string} data.sn - 设备sn
 * @param {string} data.id - 库id
 * @param {1|2|5} data.sampleType - 1-本底，2-进样, 5-已筛选
 */
export function getFcbrSampleData(data) {
  return instance.get('/fcbrMatLibrary/querySampleData', { params: data });
}

/**
 * 重置采样
 * @param {string} id 库id
 */
export function resetFcbrSampleById(id) {
  return instance.post('/fcbrMatLibrary/delSample', {
    id
  });
}

/**
 * @description 导出FCBR100CFR采样数据
 * @param {{id:string, sn:string, type: 1|2|5}} data
 */
export function downFcbrSample(data) {
  return instance.get('/fcbrMatLibrary/exportSampleData', {
    ...data
  });
}
